<template>
    <div>
        <el-radio-group v-model="humanSide" fill="#833e93" text-color="#ffffff" size="small">
            <el-radio-button label="Front"></el-radio-button>
            <el-radio-button label="Back"></el-radio-button>
        </el-radio-group>

        <div class="human-map-wrapper">
            <span :class="humanSideLowerCase + '_left'">LEFT</span>
            <span :class="humanSideLowerCase + '_right'">RIGHT</span>
            <div key="body">
                <body_f
                    v-if="humanSide === 'Front' && !isFrontAllPartsSelected"
                    :key="selectedParts.length"
                    color="#B2B2B2"
                    class="body_f">
                </body_f>
                <body_f_selected
                    v-if="humanSide === 'Front' && isFrontAllPartsSelected"
                    :key="selectedParts.length"
                    class="body_f">
                </body_f_selected>
                <body_b
                    v-if="humanSide === 'Back' && !isBackAllPartsSelected"
                    :key="selectedParts.length"
                    color="#B2B2B2"
                    class="body_b">
                </body_b>
                <body_b_selected
                    v-if="humanSide === 'Back' && isBackAllPartsSelected"
                    :key="selectedParts.length"
                    class="body_b">
                </body_b_selected>
            </div>
            <div v-for="bodyPart in humanMap" :key="bodyPart.id">
                <template v-if="bodyPart.side.toLowerCase() === humanSideLowerCase">
                    <div class="tooltip" v-if="selectedParts.filter(bp => bp.id === bodyPart.id).length">
                        <span :ref="bodyPart.id + '_tooltip'" class="tooltiptext">{{ bodyPart.tooltip }}</span>
                    </div>
                    <div 
                        :is="bodyPart.id === 'head' ? 'head_map' : bodyPart.id" 
                        :ref="bodyPart.id"
                        :key="selectedParts.length" 
                        :class="bodyPart.id"  
                        @click.native="toggle(bodyPart.id)" 
                        :color="selectedParts.filter(bp => bp.id === bodyPart.id).length ? '#833E93' : '#CCCCCC'">
                    </div>
                </template>
            </div>
        </div>
        <div class="selected-text">
            <span v-if="calcSelectedList['Front'].length" style="margin-top: 20px; ">Front<br>
                <span v-for="part in calcSelectedList['Front']" :key="part" class="bullet-text">&bull; {{ part }}</span>
            </span>
            <br><br>
            <span v-if="calcSelectedList['Back'].length" style="margin-top: 10px;">Back<br>
                <span v-for="part in calcSelectedList['Back']" :key="part" class="bullet-text">&bull; {{ part }}</span>
            </span>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import { RadioGroup, RadioButton } from 'element-ui'
    import SubQuestion from './index'
    import IconComponents from '../icon/Foot/components'

    Vue.use(RadioGroup)
    Vue.use(RadioButton)

    const humanMap = [
        { id: 'right_ankle', side: 'Front', tooltip: 'Right Ankle' },
        { id: 'left_ankle', side: 'Front', tooltip: 'Left Ankle' },
        { id: 'right_lateral_foot_f', side: 'Front', tooltip: 'Right Lateral Foot (F)' },
        { id: 'right_dorsal_foot_f', side: 'Front', tooltip: 'Right Dorsal Foot (F)' },
        { id: 'right_medial_foot_f', side: 'Front', tooltip: 'Right Medial Foot (F)' },
        { id: 'left_medial_foot_f', side: 'Front', tooltip: 'Left Medial Foot (F)' },
        { id: 'left_dorsal_foot_f', side: 'Front', tooltip: 'Left Dorsal Foot (F)' },
        { id: 'left_lateral_foot_f', side: 'Front', tooltip: 'Left Lateral Foot (F)' },
        
        { id: 'left_big_toe', side: 'Back', tooltip: 'Left Big Toe' },
        { id: 'left_long_toe', side: 'Back', tooltip: 'Left Long Toe' },
        { id: 'left_middle_toe', side: 'Back', tooltip: 'Left Middle Toe' },
        { id: 'left_ring_toe', side: 'Back', tooltip: 'Left Ring Toe' },
        { id: 'left_little_toe', side: 'Back', tooltip: 'Left Little Toe' },

        { id: 'right_big_toe', side: 'Back', tooltip: 'Right Big Toe' },
        { id: 'right_long_toe', side: 'Back', tooltip: 'Right Long Toe' },
        { id: 'right_middle_toe', side: 'Back', tooltip: 'Right Middle Toe' },
        { id: 'right_ring_toe', side: 'Back', tooltip: 'Right Ring Toe' },
        { id: 'right_little_toe', side: 'Back', tooltip: 'Right Little Toe' },
        { id: 'left_plantar_foot_b', side: 'Back', tooltip: 'Left Plantar Foot (B)' },
        { id: 'right_plantar_foot_b', side: 'Back', tooltip: 'Right Plantar Foot (B)' },
        { id: 'left_heel', side: 'Back', tooltip: 'Left Heel' },
        { id: 'right_heel', side: 'Back', tooltip: 'Right Heel' },
    ]

    export default {
        name: 'foot',
        extends: SubQuestion,
        watch: {
            humanSide: function() {
                this.$nextTick(() => this.removeTooltips())
                this.$emit('changeHumanMapSide', this.humanSide)
            }
        },

        props: {
            saved: {
                type: Array
            }
        },

        data() {
            return {
                humanMap: JSON.parse(JSON.stringify(humanMap)),
                humanSide: 'Front',
                selectedParts: [] || this.saved,
                unsortedBodyParts: [] || this.saved,
                frontTotalParts: JSON.parse(JSON.stringify(humanMap)).filter(ele => ele.side === "Front"),
                backTotalParts: JSON.parse(JSON.stringify(humanMap)).filter(ele => ele.side === "Back"),
                normalizeHumanMap: JSON.parse(JSON.stringify(humanMap)).reduce((acc,ele) => {
                    return { ...acc, [ele.id]: { ...ele }}
                }, {})
            }
        },

        mounted() {
            this.loadData()
            this.$emit('changeHumanMapSide', this.humanSide)
        },

        methods: {
            /**
             * @func placeTooltip
             * @desc places tooltip on body part selection
             * @param bodyPart(String) string indicating if the body part is active or inactive
             */
            placeTooltip(bodyPart) {
                let imgRef = this.$refs[bodyPart][0].$el
                let tooltipRef = this.$refs[bodyPart + '_tooltip'][0]
                tooltipRef.style.visibility = 'visible'

                let top = parseInt(window.getComputedStyle(imgRef, null).getPropertyValue('top').replace('px', ''))
                let left = parseInt(window.getComputedStyle(imgRef, null).getPropertyValue('left').replace('px', ''))

                tooltipRef.style.top = (top + 80) + 'px'
                // for body parts on right side of the screen
                if ((this.humanSide === 'Front' && bodyPart.includes('left')) || (this.humanSide === 'Back' && bodyPart.includes('right'))) {
                    tooltipRef.style.left = (left - 120) + 'px'
                }
                // for body parts on left side of the screen
                else if ((this.humanSide === 'Front' && bodyPart.includes('right')) || (this.humanSide === 'Back' && bodyPart.includes('left'))) {
                    tooltipRef.style.left = (left - 30) + 'px'
                }
                // for head
                else if(bodyPart.includes('head') || bodyPart.includes('neck') || bodyPart.includes('throat') || bodyPart.includes('knee') || bodyPart.includes('abdomen')) {
                    tooltipRef.style.top = (top + 50) + 'px'
                    tooltipRef.style.left = (left) + 'px'
                }
                // for middle body parts
                else tooltipRef.style.left = (left + 10) + 'px'
            },
            /**
             * @func removeTooltips
             * @desc removes all tooltips
             * @param tooltipText(String)
             */
            removeTooltips(tooltipText) {
                if (document.getElementsByClassName('tooltiptext')) {
                    let classes = document.getElementsByClassName('tooltiptext')
                    Object.keys(classes).forEach(cls => {
                        if (!tooltipText || (tooltipText && classes[cls].innerHTML.trim() === tooltipText))
                            classes[cls].style.visibility = 'hidden'
                    })
                }
            },
            loadData() {
                if (!this.saved) this.$emit('selectbp', [])
                else {
                    this.unsortedBodyParts = this.saved
                    this.selectedParts = this.saved
                    this.sortBodyParts()
                    this.$emit('selectbp', this.saved)
                }
                this.$nextTick(() => this.removeTooltips())
            },
            /**
             * @func toggle
             * @desc toggles the state of body part
             * @param bodyPart(String) string indicating if the body part is active or inactive
             */
            toggle(bodyPart) {
                // making inactive
                if (this.selectedParts.filter(bp => bp.id === bodyPart).length) {
                    this.selectedParts = this.selectedParts.filter(part => part.id !== bodyPart)
                    this.unsortedBodyParts = this.unsortedBodyParts.filter(part => part.id !== bodyPart)
                }
                // making active
                else {
                    if (this.limitReached(this.humanSide)) 
                        return

                    let tooltipText = ''
                    let reqObj = {
                        id: bodyPart,
                        value: bodyPart
                    }

                    this.selectedParts.push(reqObj)
                    this.unsortedBodyParts.push(reqObj)

                    tooltipText = this.humanMap.filter(bp => bp.id === bodyPart)[0].tooltip
                    // placing tooltip on top of the body part
                    this.$nextTick(() => this.placeTooltip(bodyPart))
                    // remove tooltip after 1.5seconds
                    setTimeout(() => this.removeTooltips(tooltipText), 1500)
                }
                // sort
                this.sortBodyParts()
                this.$emit('selectbp', this.selectedParts)
            },
            sortBodyParts() {
                let tempSelectedParts = []
                this.humanMap.forEach(bp => {
                    this.selectedParts.forEach(sp => {
                        if (sp.value === bp.id) tempSelectedParts.push(sp)
                    })
                })
                this.selectedParts = tempSelectedParts
            },
        },

        computed: {
            humanSideLowerCase() {
                return this.humanSide.toLowerCase()
            },
            calcSelectedList() {
                let selectedList = { 'Front': [], 'Back': [], 'Side': [] }
                this.unsortedBodyParts.forEach(part => {
                    let partObj = this.humanMap.filter(bodyPart => part.value === bodyPart.id)[0]
                    selectedList[partObj.side].push(partObj.tooltip)
                })
                return selectedList
            },
            isFrontAllPartsSelected() {
                return this.selectedParts.filter(ele => this.normalizeHumanMap[ele.id].side === "Front").length === this.frontTotalParts.length
            },
            isBackAllPartsSelected() {
                return this.selectedParts.filter(ele => this.normalizeHumanMap[ele.id].side === "Back").length === this.backTotalParts.length
            }
        },

        components: {
            ...IconComponents
        },
    }
</script>

<style lang="scss" scoped>
    $choice-size: 150px;
    $choice-font-size: 20px;
    @import "style.scss";

    .body_f {
        position: absolute;
        top: 84px;
        left: 40px;
    }
    .body_b {
        position: absolute;
        top: 64px;
        left: 8px;
    }

    .right_ankle {
        position: absolute;
        top: 270px;
        left: 85px;
    }

    .left_ankle {
        position: absolute;
        top: 270px;
        right: 45px;
    }

    .right_lateral_foot_f {
        position: absolute;
        top: 330px;
        left: 65px;
    }

    .right_dorsal_foot_f {
        position: absolute;
        top: 330px;
        left: 85px;
    }

    .right_medial_foot_f {
        position: absolute;
        top: 330px;
        left: 135px;
    }

    .left_lateral_foot_f {
        position: absolute;
        right: 25px;
        top: 330px;
    }

    .left_dorsal_foot_f {
        position: absolute;
        top: 330px;
        right: 45px;
    }

    .left_medial_foot_f {
        position: absolute;
        top: 330px;
        right: 95px;

    }

    .left_big_toe {
        position: absolute;
        top: 77px;
        left: 116px;
    }

    .right_big_toe {
        position: absolute;
        top: 77px;
        right: 113px;
    }

    .left_long_toe {
        position: absolute;
        top: 81px;
        left: 93px;
    }

    .right_long_toe {
        position: absolute;
        top: 81px;
        right: 90px;
    }

    .left_middle_toe {
        position: absolute;
        top: 92px;
        left: 67px;
    }

    .right_middle_toe {
        position: absolute;
        top: 92px;
        right: 64px;
    }

    .left_ring_toe {
        position: absolute;
        top: 111px;
        left: 43px;
    }

    .right_ring_toe {
        position: absolute;
        top: 111px;
        right: 40px;
    }

    .left_little_toe {
        position: absolute;
        top: 142px;
        left: 26px;
    }

    .right_little_toe {
        position: absolute;
        top: 142px;
        right: 23px;
    }

    .left_plantar_foot_b {
        position: absolute;
        top: 155px;
        left: 33px;
    }

    .right_plantar_foot_b {
        position: absolute;
        top: 155px;
        right: 32px;
    }

    .left_heel {
        position: absolute;
        top: 335px;
        left: 58px;
    }

    .right_heel {
        position: absolute;
        top: 335px;
        right: 55px;
    }
</style>
